










import {Vue, Component, Prop} from 'vue-property-decorator'
import NcpColGroup from '@/components/table/colgroup/NcpColGroup.vue';
import NcpTableBody from '@/components/table/tbody/NcpTableBody.vue';

interface ThData {
	content?: string,
}

interface TdData {
	content?: string,
	labelName?: string,
  style?: string,
}

interface TbodyContentData {
	thData: ThData,
	tdData: TdData,
}

@Component({
	components: {
		NcpColGroup,
		NcpTableBody
	}
})
export default class NcpTable extends Vue {
	@Prop() private widths?: string[]
	@Prop() private tbodyHeadData!: string[]
	@Prop() private tbodyContentData!: TbodyContentData[]
	private colWidthOption: string[] = ['100%']

	created() {
		if (this.widths) {
			this.colWidthOption = this.widths
		} else {
			const columnLength: number = this.tbodyHeadData.length
			this.colWidthOption = Array(columnLength).fill((100/columnLength).toFixed(4) + '%')
		}
	}
}
